/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CertificationProgramCreateDTO,
  CertificationProgramItemDTO,
  CertificationProgramListItemDTOPaginationResult,
  CertificationProgramUpdateDTO,
  CertificationProgramViewDTO,
  GetApiCertificationProgramListParams,
  PostApiCertificationProgramIdItemsItemIdVideoBody,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiCertificationProgramList = (
    params?: GetApiCertificationProgramListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationProgramListItemDTOPaginationResult>(
      {url: `/api/CertificationProgram/list`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiCertificationProgramListInfiniteQueryKey = (params?: GetApiCertificationProgramListParams,) => {
    return [
    'infinite', `/api/CertificationProgram/list`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiCertificationProgramListQueryKey = (params?: GetApiCertificationProgramListParams,) => {
    return [
    `/api/CertificationProgram/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCertificationProgramListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramList>>>, TError = ProblemDetails>(params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramList>>> = ({ signal }) => getApiCertificationProgramList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramList>>>
export type GetApiCertificationProgramListInfiniteQueryError = ProblemDetails


export function useGetApiCertificationProgramListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramList>>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationProgramListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationProgramListQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError = ProblemDetails>(params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramList>>> = ({ signal }) => getApiCertificationProgramList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramList>>>
export type GetApiCertificationProgramListQueryError = ProblemDetails


export function useGetApiCertificationProgramList<TData = Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationProgramListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramList<TData = Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramList<TData = Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramList<TData = Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError = ProblemDetails>(
 params?: GetApiCertificationProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCertificationProgramId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationProgramViewDTO>(
      {url: `/api/CertificationProgram/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiCertificationProgramIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/CertificationProgram/${id}`
    ] as const;
    }

export const getGetApiCertificationProgramIdQueryKey = (id: string,) => {
    return [
    `/api/CertificationProgram/${id}`
    ] as const;
    }


export const getGetApiCertificationProgramIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramId>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramId>>> = ({ signal }) => getApiCertificationProgramId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramId>>>
export type GetApiCertificationProgramIdInfiniteQueryError = ProblemDetails


export function useGetApiCertificationProgramIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramId>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationProgramIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramId>>> = ({ signal }) => getApiCertificationProgramId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramId>>>
export type GetApiCertificationProgramIdQueryError = ProblemDetails


export function useGetApiCertificationProgramId<TData = Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramId<TData = Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramId<TData = Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramId<TData = Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiCertificationProgramId = (
    id: string,
    certificationProgramUpdateDTO?: CertificationProgramUpdateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationProgramViewDTO>(
      {url: `/api/CertificationProgram/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: certificationProgramUpdateDTO, signal
    },
      options);
    }




export const getPutApiCertificationProgramIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationProgramId>>, TError,{id: string;data?: CertificationProgramUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationProgramId>>, TError,{id: string;data?: CertificationProgramUpdateDTO}, TContext> => {

const mutationKey = ['putApiCertificationProgramId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCertificationProgramId>>, {id: string;data?: CertificationProgramUpdateDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiCertificationProgramId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCertificationProgramIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCertificationProgramId>>>
    export type PutApiCertificationProgramIdMutationBody = CertificationProgramUpdateDTO | undefined
    export type PutApiCertificationProgramIdMutationError = ProblemDetails

    export const usePutApiCertificationProgramId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationProgramId>>, TError,{id: string;data?: CertificationProgramUpdateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCertificationProgramId>>,
        TError,
        {id: string;data?: CertificationProgramUpdateDTO},
        TContext
      > => {
      return useMutation(getPutApiCertificationProgramIdMutationOptions(options), queryClient);
    }
    export const deleteApiCertificationProgramId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/CertificationProgram/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiCertificationProgramIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiCertificationProgramId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCertificationProgramId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiCertificationProgramId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCertificationProgramIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCertificationProgramId>>>

    export type DeleteApiCertificationProgramIdMutationError = ProblemDetails

    export const useDeleteApiCertificationProgramId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCertificationProgramId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiCertificationProgramIdMutationOptions(options), queryClient);
    }
    export const postApiCertificationProgram = (
    certificationProgramCreateDTO?: CertificationProgramCreateDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationProgramViewDTO>(
      {url: `/api/CertificationProgram`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: certificationProgramCreateDTO, signal
    },
      options);
    }




export const getPostApiCertificationProgramMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgram>>, TError,{data?: CertificationProgramCreateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgram>>, TError,{data?: CertificationProgramCreateDTO}, TContext> => {

const mutationKey = ['postApiCertificationProgram'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCertificationProgram>>, {data?: CertificationProgramCreateDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiCertificationProgram(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCertificationProgramMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCertificationProgram>>>
    export type PostApiCertificationProgramMutationBody = CertificationProgramCreateDTO | undefined
    export type PostApiCertificationProgramMutationError = ProblemDetails

    export const usePostApiCertificationProgram = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgram>>, TError,{data?: CertificationProgramCreateDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCertificationProgram>>,
        TError,
        {data?: CertificationProgramCreateDTO},
        TContext
      > => {
      return useMutation(getPostApiCertificationProgramMutationOptions(options), queryClient);
    }
    export const postApiCertificationProgramIdItemsItemIdVideo = (
    id: string,
    itemId: string,
    postApiCertificationProgramIdItemsItemIdVideoBody?: PostApiCertificationProgramIdItemsItemIdVideoBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCertificationProgramIdItemsItemIdVideoBody?.file !== undefined) {
 formData.append(`file`, postApiCertificationProgramIdItemsItemIdVideoBody.file);
 }

      return customInstance<CertificationProgramItemDTO>(
      {url: `/api/CertificationProgram/${id}/items/${itemId}/video`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPostApiCertificationProgramIdItemsItemIdVideoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string;data?: PostApiCertificationProgramIdItemsItemIdVideoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string;data?: PostApiCertificationProgramIdItemsItemIdVideoBody}, TContext> => {

const mutationKey = ['postApiCertificationProgramIdItemsItemIdVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>, {id: string;itemId: string;data?: PostApiCertificationProgramIdItemsItemIdVideoBody}> = (props) => {
          const {id,itemId,data} = props ?? {};

          return  postApiCertificationProgramIdItemsItemIdVideo(id,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCertificationProgramIdItemsItemIdVideoMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>>
    export type PostApiCertificationProgramIdItemsItemIdVideoMutationBody = PostApiCertificationProgramIdItemsItemIdVideoBody | undefined
    export type PostApiCertificationProgramIdItemsItemIdVideoMutationError = ProblemDetails

    export const usePostApiCertificationProgramIdItemsItemIdVideo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string;data?: PostApiCertificationProgramIdItemsItemIdVideoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCertificationProgramIdItemsItemIdVideo>>,
        TError,
        {id: string;itemId: string;data?: PostApiCertificationProgramIdItemsItemIdVideoBody},
        TContext
      > => {
      return useMutation(getPostApiCertificationProgramIdItemsItemIdVideoMutationOptions(options), queryClient);
    }
    export const deleteApiCertificationProgramIdItemsItemIdVideo = (
    id: string,
    itemId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/CertificationProgram/${id}/items/${itemId}/video`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiCertificationProgramIdItemsItemIdVideoMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string}, TContext> => {

const mutationKey = ['deleteApiCertificationProgramIdItemsItemIdVideo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>, {id: string;itemId: string}> = (props) => {
          const {id,itemId} = props ?? {};

          return  deleteApiCertificationProgramIdItemsItemIdVideo(id,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCertificationProgramIdItemsItemIdVideoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>>

    export type DeleteApiCertificationProgramIdItemsItemIdVideoMutationError = ProblemDetails

    export const useDeleteApiCertificationProgramIdItemsItemIdVideo = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>, TError,{id: string;itemId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCertificationProgramIdItemsItemIdVideo>>,
        TError,
        {id: string;itemId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCertificationProgramIdItemsItemIdVideoMutationOptions(options), queryClient);
    }
    export const getApiCertificationProgramIdItemsItemIdVideoStream = (
    id: string,
    itemId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/CertificationProgram/${id}/items/${itemId}/video/stream`, method: 'GET', signal
    },
      options);
    }




export const getGetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryKey = (id: string,
    itemId: string,) => {
    return [
    'infinite', `/api/CertificationProgram/${id}/items/${itemId}/video/stream`
    ] as const;
    }

export const getGetApiCertificationProgramIdItemsItemIdVideoStreamQueryKey = (id: string,
    itemId: string,) => {
    return [
    `/api/CertificationProgram/${id}/items/${itemId}/video/stream`
    ] as const;
    }


export const getGetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>, TError = void | ProblemDetails>(id: string,
    itemId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryKey(id,itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>> = ({ signal }) => getApiCertificationProgramIdItemsItemIdVideoStream(id,itemId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && itemId !== null && itemId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>
export type GetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryError = void | ProblemDetails


export function useGetApiCertificationProgramIdItemsItemIdVideoStreamInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdItemsItemIdVideoStreamInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdItemsItemIdVideoStreamInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramIdItemsItemIdVideoStreamInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramIdItemsItemIdVideoStreamInfiniteQueryOptions(id,itemId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationProgramIdItemsItemIdVideoStreamQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError = void | ProblemDetails>(id: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationProgramIdItemsItemIdVideoStreamQueryKey(id,itemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>> = ({ signal }) => getApiCertificationProgramIdItemsItemIdVideoStream(id,itemId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && itemId !== null && itemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationProgramIdItemsItemIdVideoStreamQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>>
export type GetApiCertificationProgramIdItemsItemIdVideoStreamQueryError = void | ProblemDetails


export function useGetApiCertificationProgramIdItemsItemIdVideoStream<TData = Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdItemsItemIdVideoStream<TData = Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationProgramIdItemsItemIdVideoStream<TData = Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationProgramIdItemsItemIdVideoStream<TData = Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError = void | ProblemDetails>(
 id: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationProgramIdItemsItemIdVideoStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationProgramIdItemsItemIdVideoStreamQueryOptions(id,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






